import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["../auth.styles.css"]
})
export class LoginComponent implements OnInit {
  public type: string = "";
  showContent;

  constructor(private _router: Router, private renderer: Renderer2) {
    this.renderer.removeClass(document.body, 'bodyWithoutBack');
  }

  ngOnInit() {
    setTimeout(() => this.showContent = true, 450);
  }

  navigate( type: ('company' | 'executive') ) {
    this._router.navigate([`/login/${type}`]);  
  }

  
}
